import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../core/services/helpers.service';
import { OperationsService } from '../../core/services/operations.service';
import { DettaglioEsitoAdapter } from '../components/fascicolo/esiti-update/dettaglio-esito-adapter';
import { Classificazione } from '../models/classificazione';
import { Controparte } from '../models/controparte';
import { DettaglioEsito } from '../models/dettaglio-esito';
import { ClassificazioneResponse } from '../models/dto/classificazione-response';
import { SezioneContropartiResponse } from '../models/dto/sezione-controparti-response';
import { TipoGenericoRimovibile } from '../models/tipologiche/tipo-generico-rimovibile';
import { BaseForm } from './base-Form';

export abstract class EsitoMeritoForm extends BaseForm {

  tipiDettaglioEsito: TipoGenericoRimovibile[] = [];
  controparti: Controparte[] = [];
  dettaglioEsito: DettaglioEsito;
  classificazioni: Classificazione[] = [];

  classificazioniOptions: Classificazione[]=[];
  contropartiOptions: Controparte[]=[];
  meritoForm: FormGroup;

  dettagliEsito: DettaglioEsito[]=[];
  contropartiDettagli: Controparte[]=[];

  constructor(private helpers: HelpersService, protected operationsService: OperationsService, private formBuilder: FormBuilder) {
    super();
  }

  populateSelect(urlSezioneControparti: string, idSezioneControparti: string, urlSezioneClassificazioni: string, idSezioneClassificazione: string) {
    if (this.tipiDettaglioEsito.length === 0) {
      this.helpers.getTipiDettaglioEsito().subscribe(response => this.tipiDettaglioEsito = response);
    }

    if (this.controparti.length === 0) {
      this.operationsService.readSezione(urlSezioneControparti, idSezioneControparti).subscribe(
        response => this.processControparti((<SezioneContropartiResponse>response).sezione.controparti));
    }

    if (this.classificazioni.length === 0) {
      this.operationsService.readSezione(urlSezioneClassificazioni, idSezioneClassificazione)
          .subscribe(response => this.classificazioni = (<ClassificazioneResponse>response).sezione.classificazioni.sort((leftSide, rigthSide): number => {
              if (leftSide.materia < rigthSide.materia) return -1;
              if (leftSide.materia > rigthSide.materia) return 1;
              return 0;
            }));
    }
    if(this.inserimento){
      this.contropartiDettagli=[];
    }
  }

  processControparti(controparti: Controparte[]) {
    this.controparti = controparti.sort((leftSide, rigthSide): number => {
            if (leftSide.parte.cognome < rigthSide.parte.cognome) { return -1; }
            if (leftSide.parte.cognome > rigthSide.parte.cognome) { return 1; }
            return 0;
          });
  }

  createForm() {
    this.dettaglioEsito = DettaglioEsitoAdapter.cloneMerito(this.getMeritoEsito());
    this.meritoForm = this.formBuilder.group({
      controparte: [this.dettaglioEsito.controparte],
      dettaglioEsito: [this.dettaglioEsito.tipoDettaglio, Validators.required],
      classificazione: [this.dettaglioEsito.classificazione, Validators.required]
    });
  }

  readClassificazioni(idPratica){
    this.operationsService.readClassificazione(idPratica).subscribe(response=>{
      this.classificazioniOptions=response.pratica.classificazioni;
    });
  }

  onSelectAllControparti(event){
    this.contropartiDettagli = (event) ? this.controparti : [];
  }

  onSelectControparte(event, controparte: Controparte) {
    (event) ? this.contropartiDettagli.push(controparte) : this.contropartiDettagli = this.contropartiDettagli.filter(el=>el.id!==controparte.id);
  }

  isSelectedControparte(controparte: Controparte):boolean {
    return (this.contropartiDettagli.find(el=>el.id===controparte.id)) ? true : false;
  }

  createListDettagli(): DettaglioEsito[]{
    let list: DettaglioEsito[] = [];
    this.contropartiDettagli.forEach(element=>{
      let dettaglio = new DettaglioEsito();
      dettaglio.classificazione=this.dettaglioEsito.classificazione;
      dettaglio.tipoDettaglio=this.dettaglioEsito.tipoDettaglio;
      dettaglio.controparte=element;
      list.push(dettaglio);
    });
    return list;
  }

  update() {
    this.dettagliEsito = this.createListDettagli();
    this.getRequest(this.inserimento ? this.dettagliEsito : this.dettaglioEsito);
  }

  abstract getRequest(meritoEsito: DettaglioEsito | DettaglioEsito[]);
  abstract getMeritoEsito(): DettaglioEsito;
}
